import { GetApiCall } from "./axiosSetup";

export const OPEN_CASHIER = '/cashier/open-cashier';

export const OpenCashier = async (activeTab) => GetApiCall(OPEN_CASHIER + "?activeTab=" + activeTab, "https://api.goatspins.com");